/* eslint-disable array-bracket-newline */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ICompetitionTrade } from '@kattana-io/common';
import TradesTable from './Table';
import TradesTableMobile from './TableMobile';
import { IStore } from '../../../../reducers';
import { authTokenSelector } from '../../../../selectors/auth';
import { CexAPI } from '../../../../store/createStore';
import useDevice from '../../../MainPage/useMobileDetect';

export interface ICompetitionTradesDataLayerProps {
  width?: number;
}

const CompetitionTradesDataLayer = ({
  width,
}: ICompetitionTradesDataLayerProps) => {
  const timezone = useSelector((state: IStore) => state.timezone.current);
  const authToken = useSelector(authTokenSelector);
  const loggedIn = useSelector((state: IStore) => state.auth.loggedIn);
  const { isMobile } = useDevice();

  const { exchange } = useParams();

  const [trades, setTrades] = useState<ICompetitionTrade[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    if (loggedIn) {
      CexAPI.fetchCompetitionTrades(
        exchange || 'binance',
        authToken!,
        0,
        controller
      ).then((data) => {
        setTrades(data || []);
        setLoading(false);
      });
    } else {
      setTrades([]);
      setLoading(false);
    }
    return () => {
      controller.abort();
    };
  }, [authToken, exchange, loggedIn]);

  return isMobile ? (
    <TradesTableMobile timezone={timezone} trades={trades} loading={loading} />
  ) : (
    <TradesTable
      timezone={timezone}
      trades={trades}
      loading={loading}
      width={width}
    />
  );
};

export default CompetitionTradesDataLayer;
